module.exports = __webpack_public_path__ + "static/media/banner-img-work-v2.a547e836.png";